import { render, staticRenderFns } from "./SpinnerLive.vue?vue&type=template&id=2a3124b7&scoped=true&"
import script from "./SpinnerLive.vue?vue&type=script&lang=js&"
export * from "./SpinnerLive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3124b7",
  null
  
)

export default component.exports